<template>
  <div>
    <Navbar />
    <slot />
    <UpdatePassword />
    <showProfile />
    <Footer />
    <div id="overlay">      
      <font-awesome-icon class="loading-icon" icon="spinner" size="2x" pulse />
    </div>
  </div>
</template>

<script>
import Navbar from "@/layouts/Navbar";
import Footer from "@/layouts/Footer";
import UpdatePassword from "@/layouts/UpdatePassword";
import showProfile from "@/layouts/showProfile";

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    UpdatePassword,
    showProfile
  }
};
</script>


// WEBPACK FOOTER //
// src/layouts/Default.vue